import {remCalc} from '_themeUtils'
import searchResults from './partials/search-results'
import searchSuggestions from './partials/search-suggestions'
import {ThemeBreakpoints} from '_uiComponents'

interface StyleProps {
    headerSize?: ThemeBreakpoints
}

const searchSectionBase = {
    SearchSection: {
        baseStyle: ({headerSize}: StyleProps) => ({
            container: {
                bg: 'color.background.header.default',
                px: {base: 'spacing.6', lg: 'spacing.8', xl: 'spacing.16'},
                pb: 'spacing.10',
                position: {base: 'fixed', lg: 'unset'},
                minW: {base: 'full', lg: 'unset'},
                minH: {base: 'full', lg: 'unset'},
                top: 0,
                left: 0,
                maxH: headerSize && {
                    base: 'full',
                    lg: `calc(100dvh - ${headerSize.lg}px)`,
                    '2xl': `calc(100dvh - ${headerSize['2xl']}px)`,
                },
                overflowY: 'auto',
                zIndex: 'modal',
            },
            searchBox: {
                mb: {lg: 'spacing.6'},
                maxWidth: remCalc(400),
                mx: 'auto',
            },
            searchErrorLabel: {
                pb: 'spacing.8',
                textStyle: 'paragraphXs',
                letterSpacing: remCalc(0.5),
                color: 'color.text.error',
                fontWeight: 400,
                mt: remCalc(-24),
                pl: 'spacing.2',
            },
            mobileHeader: {
                justify: 'flex-end',
                mr: remCalc(-14),
            },
            productsGrid: {
                columns: {base: 3, lg: 2, xl: 4},
                spacingX: {base: 'spacing.6', lg: 'spacing.4', xl: 'spacing.10'},
                spacingY: {base: 'spacing.6', lg: 'spacing.4', xl: 'spacing.8'},
            },
            productSkeleton: {
                w: 'full',
                h: 'full',
            },
        }),
    },
}

const searchSection = {
    ...searchSectionBase,
    ...searchSuggestions,
    ...searchResults,
}

export default searchSection
